import { Empty } from 'antd';
import { useTranslate } from '@refinedev/core';
import { DataTable } from '../../../data-table';
import React, { FC, useMemo } from 'react';

interface ExpertisesProps {
    data: any[];
    group: string;
}

export const Expertises: FC<ExpertisesProps> = ({ data, group }) => {
    const t = useTranslate();

    const normalizedData = useMemo(
        () => (Array.isArray(data) ? data : []),
        [data]
    );

    const mappedData = useMemo(
        () =>
            normalizedData.map(({ conclusions, ...restProps }) => {
                const { createdOn, doneDateFact, receivedOn, ...props } =
                    restProps;

                return {
                    ...props,
                    createdOn: createdOn?.split(' ')[0],
                    doneDateFact: doneDateFact?.split(' ')[0],
                    receivedOn: receivedOn?.split(' ')[0],
                };
            }),
        [normalizedData]
    );

    if (mappedData.length === 0) {
        return <Empty description={t('applications.titles.no_data')} />;
    }

    return (
        <DataTable
            data={mappedData}
            group={group}
        />
    );
};
